import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-integration-setup",
	templateUrl: "./integration-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class IntegrationSetupComponent implements OnInit, OnDestroy {
	changesToSave: boolean = false;

	loaded: boolean = false;

	viewMode: number = 0;

	constructor(public app: AppService, public venueService: OOVenueService) {}
	ngOnDestroy(): void {}

	ngOnInit(): void {
		this.app.loading(true);
		this.venueService.integratorRequestListGet();
		this.venueService.menuGet();

		this.venueService.subscriptionOOmenu.subscribe((ooMenu) => {
			this.app.loading(false);
			this.loaded = true;
		});
	}

	async onSave() {
		this.venueService.ooVenueSave();
		this.venueService.venueSave();
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Integration settings saved successfully.` });
	}
}
